<template>
  <Modal
    :isOpen="isOpen"
    @update:isOpen="$emit('update:isOpen', $event)"
    modalId="order-cancel-container-modal"
    maxWidth="md"
    @close="onCancel"
  >
    <template #title>Cancel container</template>
    <template #subtitle>
      <span v-if="containerLabel">{{ containerLabel }}</span>
    </template>
    <template #content="{ close }">
      <p class="tw-mb-3 tw-text-sm tw-text-slate-600">
        This container will stay on the order but trips cannot be added or completed.
      </p>
      <InputField
        id="cancelledReason"
        label="Cancellation reason"
        v-model="cancelledReasonInput"
        placeholder="e.g. Not our drayage"
      />
      <div class="tw-mt-6 tw-flex tw-items-center tw-justify-end tw-gap-2">
        <Button
          :isGreen="true"
          :isPrimary="true"
          :disabled="!canSubmit"
          class="tw-p-0"
          icon="check"
          title="Cancel container"
          aria-label="Cancel container"
          @click="onSubmit"
        >
          Cancel container
        </Button>
        <Button
          :isRed="true"
          :isSecondary="true"
          class="tw-p-0"
          title="Close"
          aria-label="Close cancel container dialog"
          @click="close"
        >
          Close
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';

import Modal from '@/components/core/Modal/Modal.vue';
import InputField from '@/components/core/Input/InputField.vue';
import Button from '@/components/core/Button.vue';

export default defineComponent({
  name: 'OrderCancelContainerModal',
  components: {
    Modal,
    InputField,
    Button,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    containerLabel: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  emits: ['update:isOpen', 'cancel', 'submit'],
  data() {
    return {
      cancelledReasonInput: '',
    };
  },
  computed: {
    canSubmit(): boolean {
      return Boolean((this as any).cancelledReasonInput?.trim());
    },
  },
  watch: {
    isOpen(isOpen: boolean) {
      if (isOpen) {
        (this as any).cancelledReasonInput = '';
      }
    },
  },
  methods: {
    onCancel() {
      (this as any).$emit('cancel');
    },
    onSubmit() {
      const reason = (this as any).cancelledReasonInput?.trim();
      if (!reason) return;
      (this as any).$emit('submit', reason);
    },
  },
});
</script>
